namespace RedBullMOBILE360.Sms {
    export interface AddonRow {
        Id?: string;
        Category?: string;
        NameAr?: string;
        NameEn?: string;
        IsActive?: number;
        Price?: number;
        Benefits?: string;
        Validity?: number;
        BenefitsAr?: string;
        Commission?: number;
        AllowedChannles?: string;
        AllowedIdTypes?: string;
        EsimOfferId?: string;
    }

    export namespace AddonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Sms.Addon';
        export const lookupKey = 'Sms.Addon';

        export function getLookup(): Q.Lookup<AddonRow> {
            return Q.getLookup<AddonRow>('Sms.Addon');
        }
        export const deletePermission = 'Sms:Addon';
        export const insertPermission = 'Sms:Addon';
        export const readPermission = 'Sms:Addon';
        export const updatePermission = 'Sms:Addon';

        export declare const enum Fields {
            Id = "Id",
            Category = "Category",
            NameAr = "NameAr",
            NameEn = "NameEn",
            IsActive = "IsActive",
            Price = "Price",
            Benefits = "Benefits",
            Validity = "Validity",
            BenefitsAr = "BenefitsAr",
            Commission = "Commission",
            AllowedChannles = "AllowedChannles",
            AllowedIdTypes = "AllowedIdTypes",
            EsimOfferId = "EsimOfferId"
        }
    }
}
